import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Popover, Stack, Divider } from '@hub-la/design-system';
import { Analytics, AnalyticsEvent } from '@hub-la/fe-core-analytics';
import { useRoleplay } from '@hub-la/fe-roleplay';
import { useSignOut } from '@hub-la/fe-sign-out';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import { useTranslation } from 'react-i18next';
import { getAppUrl, routes, isAtSite, getAppHost } from '../../utils/routes.js';
import img from '../assets/default-user-avatar.js';
import { useContainer } from '../hooks/use-container.js';
import { DropdownButton } from './dropdown-button.js';
import { DropdownHeader } from './dropdown-header.js';
import { MenuLink } from './menu-link.js';

const AccountDropdown = props => {
  const {
    t
  } = useTranslation();
  const {
    execute: signOut
  } = useSignOut();
  const {
    signOut: signOutRoleplay,
    isRoleplay
  } = useRoleplay();
  const container = useContainer();
  const analytics = container.get(Analytics);
  const events = AnalyticsEvent.MAIN_MENU;
  const userPicture = props.picture ? props.picture : String(img);
  const onClickMenuLink = (route, event, close) => {
    analytics.track(event);
    if (route.startsWith(window.location.origin)) {
      props.push(route.replace(window.location.origin, ''));
    } else {
      window.location.href = route;
    }
    // close popover
    close();
  };
  const onClickSignOut = close => __awaiter(void 0, void 0, void 0, function* () {
    // SignOut
    if (isRoleplay) {
      yield signOutRoleplay();
    }
    signOut().then(() => {
      // trigged event
      analytics.track(events.LOGOUT_CLICKED);
      // close popover
      close();
      // when at the site, should redirect to logout page from app to sign out there
      isAtSite() && window.location.replace(`${getAppHost()}/logout`);
    });
  });
  const onClickHandleSelectAccount = close => __awaiter(void 0, void 0, void 0, function* () {
    if (isRoleplay) {
      yield signOutRoleplay();
    }
    onClickMenuLink(getAppUrl(routes.ROLEPLAY), events.ROLEPLAY_CLICKED, close);
  });
  const hasSelected = route => {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return false;
    }
    return window.location.href.includes(route);
  };
  const getUsername = () => {
    var _a;
    return (_a = props.username && props.username.length > 1 ? props.username : props.id) !== null && _a !== void 0 ? _a : '';
  };
  return jsx(Popover, Object.assign({
    items: ({
      close
    }) => jsxs(Stack, Object.assign({
      width: 280
    }, {
      children: [jsx(DropdownHeader, {
        firstName: props.firstName,
        username: getUsername(),
        picture: userPicture,
        push: props.push,
        close: close
      }), jsx(MenuLink, {
        startIcon: jsx(CategoryOutlinedIcon, {}),
        label: t('dropdown.links.products'),
        selected: hasSelected(routes.PRODUCTS),
        onClick: () => onClickMenuLink(getAppUrl(routes.PRODUCTS), events.PRODUCTS_CLICKED, close)
      }), jsx(MenuLink, {
        startIcon: jsx(ShoppingBasketOutlinedIcon, {}),
        label: t('dropdown.links.purchases'),
        selected: hasSelected(routes.PURCHASES),
        onClick: () => onClickMenuLink(getAppUrl(routes.PURCHASES), events.PURCHASES_CLICKED, close),
        hidden: isRoleplay
      }), !isRoleplay && jsx(Divider, {
        marginX: 3
      }), jsx(MenuLink, {
        startIcon: jsx(PersonOutlineIcon, {}),
        label: t('dropdown.links.affiliates'),
        selected: hasSelected(routes.AFFILIATES),
        onClick: () => onClickMenuLink(getAppUrl(routes.AFFILIATES), events.AFFILIATES_CLICKED, close),
        hidden: isRoleplay
      }), jsx(MenuLink, {
        startIcon: jsx(AutoStoriesOutlinedIcon, {}),
        label: t('dropdown.links.blog'),
        selected: hasSelected(routes.BLOG),
        onClick: () => {
          analytics.track(events.BLOG_CLICKED);
          window.open(routes.BLOG);
          close();
        }
      }), jsx(MenuLink, {
        startIcon: jsx(InfoOutlinedIcon, {}),
        label: t('dropdown.links.support'),
        selected: hasSelected(routes.SUPPORT),
        onClick: () => {
          analytics.track(events.SUPPORT_CLICKED);
          window.open(routes.SUPPORT);
          close();
        }
      }), jsx(MenuLink, {
        startIcon: jsx(GroupAddOutlinedIcon, {}),
        label: t('dropdown.links.collaborators'),
        selected: hasSelected(routes.COLLABORATORS),
        onClick: () => onClickMenuLink(getAppUrl(routes.COLLABORATORS), events.COLLABORATORS_CLICKED, close),
        hidden: isRoleplay
      }), jsx(Divider, {
        marginX: 3
      }), jsx(MenuLink, {
        startIcon: jsx(UndoIcon, {}),
        label: t('dropdown.links.selectAccount'),
        selected: hasSelected(routes.ROLEPLAY),
        onClick: () => onClickHandleSelectAccount(close)
      }), jsx(MenuLink, {
        label: t('dropdown.links.logout'),
        onClick: () => onClickSignOut(close)
      })]
    }))
  }, {
    children: jsx(DropdownButton, {
      firstName: props.firstName,
      picture: userPicture
    })
  }));
};

export { AccountDropdown };
